/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

import CourseListItemCategory from './CourseListItemCategory';
import CourseListItemStartEnd from './CourseListItemStartEnd';
import CourseListItemStatus from './CourseListItemStatus';
import CourseListItemVenue from './CourseListItemVenue';
import CourseListItemButtons from './CourseListItemButtons';

const parseSlug = (url) => {
	return url.split('/').filter(Boolean).pop();
};

/**
 * CourseListItem Component
 * @param {Object} props
 * @returns {JSX.Element}
 */
function CourseListItem({
	id,
	name,
	description,
	imageUrl,
	startDate,
	endDate,
	status,
	venues,
	categories,
	url,
	registrationUrl,
}) {
	const { archiveUrl } = window.visitEduSettings;

	return (
		<li
			className="upcoming-event-list__item"
			onClick={(event) => {
				event.preventDefault();

				if (event.target.nodeName !== 'A') {
					url && window.open(archiveUrl + parseSlug(url), '_blank');
				} else {
					window.open(event.target.href, '_blank');
				}
			}}
		>
			<div className="upcoming-event-list__item__image">
				<img src={imageUrl} alt={name} />
				<CourseListItemCategory categories={categories} />
				<CourseListItemStatus status={status} />
			</div>
			<h3 className="upcoming-event-list__item__heading">
				{decodeEntities(name)}
			</h3>
			<CourseListItemStartEnd start={startDate} end={endDate} />
			<CourseListItemVenue venues={venues} />
			<p className="upcoming-event-list__item__description">
				{decodeEntities(description)}
			</p>
			<CourseListItemButtons
				id={id}
				url={url}
				status={status}
				registrationUrl={registrationUrl}
			/>
		</li>
	);
}

export default CourseListItem;
